import http from 'hub-http/clients/apiClient';
const BASE_URI = 'inbounddb-objects/v1/crm-objects';
export const fetchRecordById = (objectTypeId, subjectId) => {
  return http.get(`${BASE_URI}/${objectTypeId}/${subjectId}?flpViewValidation=true`);
};